import { render, staticRenderFns } from "./workorder.vue?vue&type=template&id=190b1f91&scoped=true"
import script from "./workorder.vue?vue&type=script&lang=js"
export * from "./workorder.vue?vue&type=script&lang=js"
import style0 from "./workorder.vue?vue&type=style&index=0&id=190b1f91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b1f91",
  null
  
)

export default component.exports